// extracted by mini-css-extract-plugin
module.exports = {"contentWrapper":"SearchFilters-module__contentWrapper___4WCvG"};